<template>
  <div class="cart-checkout" v-if="cart_items_count">
    <div class="details">
      <h4>{{ _T('Bill amount') }}</h4>
      <span>{{ currency }} {{ Num.price(cart_sub_total_all) }}</span>
    </div>
    <!--  && (selectedDa || order_type == CONST.ORDER_TYPE_DINEIN) -->
    <router-link
      :to="{
        name: brandStoreRoute('cart'),
      }"
      :event="cart_items_count ? 'click' : ''"
      :class="{ disabled: !cart_items_count }"
      class="btn btn-solid btn-block"
      @click.native="closeCartSidebar"
      >{{ _T('Checkout') }}</router-link
    >
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { eventBus } from '@/eventBus'
export default {
  data() {
    return {
      brand_id: '',
      store_id: '',
    }
  },
  watch: {
    cart_brand_store: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            this.brand_id = val.brand_id || ''
            this.store_id = val.store_id || ''
          })
        }
      },
    },
  },
  computed: {
    ...mapGetters([
      '_T',
      'cart_sub_total_all',
      'cart_items_count',
      'brandStoreParams',
      'brandStoreRoute',
      'currentBrandId',
      'currentStoreId',
      'cart_brand_store',
      'selectedDa',
      'order_type',
    ]),
  },
  methods: {
    closeCartSidebar() {
      if (!this.selectedDa && this.order_type == 'online') {
        eventBus.$emit('scrollToDA')
      }
      this.setBrandStoreId()
      this.$store.dispatch('calculateLoyaltyAmountForItem')
      this.$store.commit('OPEN_CART_SIDEBAR')
      document.body.classList.remove('body-overlay')
    },
    setBrandStoreId() {
      let brandId = ''
      let storeId = ''

      if (this.currentBrandId) {
        brandId = this.currentBrandId
      } else if (this.$route.params.brand_id) {
        brandId = this.$route.params.brand_id
      } else {
        brandId = this.cart_brand_store.brand_id || ''
      }

      if (this.currentStoreId) {
        brandId = this.currentStoreId
      } else if (this.$route.params.store_id) {
        brandId = this.$route.params.store_id
      } else {
        brandId = this.cart_brand_store.store_id || ''
      }
      this.brand_id = brandId
      this.store_id = storeId
    },
  },
}
</script>

<style lang="scss" scoped>
.cart-checkout {
  padding: 1.875rem;
  border-top: $px1 solid $light-border;
  position: absolute;
  width: 100%;
  bottom: 0;
  background-color: $white !important;
  .btn {
    text-transform: capitalize;
  }
  a.disabled {
    opacity: 0.3;
  }
  .details {
    display: flex !important;
    align-items: baseline !important;
    justify-content: space-between !important;
    margin-bottom: 1.125rem;
    h4 {
      font-size: 1.25rem;
      margin-bottom: 0;
      text-transform: capitalize;
      font-weight: 600;
      line-height: 1.5rem;
    }
    span {
      margin-left: auto;
      text-transform: uppercase;
      font-weight: 700;
      font-size: 1.25rem;
      line-height: 1.5rem;
    }
  }
}
</style>
